<template>
  <img :src="avatarSrc" alt="User Avatar" :class="imageClass" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { AvatarPreferences } from '@/types/avatar'
import { generateAvatarSvgDataUri } from '@/lib/avatar/generator'

defineOptions({
  name: 'AvataaarComponent',
})

export interface AvatarConfig {
  avatarStyle?: string
  isCircle?: boolean
  circleColor?: string
  topType?: string
  topColor?: string
  accessoriesType?: string
  hairColor?: string
  facialHairType?: string
  facialHairColor?: string
  clotheType?: string
  clotheColor?: string
  graphicType?: string
  eyeType?: string
  eyebrowType?: string
  mouthType?: string
  skinColor?: string
}

const props = withDefaults(defineProps<AvatarConfig>(), {
  avatarStyle: 'Transparent',
  isCircle: true,
  circleColor: '#43f7b4',
  topType: 'ShortHairShortFlat',
  topColor: 'Black',
  accessoriesType: 'Blank',
  hairColor: 'BrownDark',
  facialHairType: 'Blank',
  facialHairColor: 'BrownDark',
  clotheType: 'BlazerShirt',
  clotheColor: 'Blue01',
  eyeType: 'Happy',
  eyebrowType: 'Default',
  mouthType: 'Smile',
  skinColor: 'Light',
  graphicType: 'Bat',
})

const imageClass = computed(() => (props.isCircle ? 'rounded-full' : ''))

const preferences = computed<AvatarPreferences>(() => ({
  isCircle: props.isCircle,
  circleColor: props.circleColor,
  topType: props.topType,
  topColor: props.topColor,
  accessoriesType: props.accessoriesType,
  hairColor: props.hairColor,
  facialHairType: props.facialHairType,
  facialHairColor: props.facialHairColor,
  clotheType: props.clotheType,
  clotheColor: props.clotheColor,
  graphicType: props.graphicType ?? 'Bat',
  eyeType: props.eyeType,
  eyebrowType: props.eyebrowType,
  mouthType: props.mouthType,
  skinColor: props.skinColor,
}))

const avatarSrc = computed(() => generateAvatarSvgDataUri(preferences.value))
</script>
